import type { IFileItem } from '../models/FileItem';
import type { IFolderItem } from '../models/FolderItem';

export function fileBaseName(file: IFileItem): string {
  return file.extension ? file.name.substring(0, file.name.length - file.extension.length - 1) : file.name;
}

export function filePath(file: IFileItem): string {
  return file.parentPath ? `${file.parentPath}/${file.name}` : file.name;
}

export function folderLabel(folder: IFolderItem): string {
  return folder.path || folder.name;
}

/** Removes a trailing ' (1)'-style copy counter. */
export function stripCopyCounter(name: string): string {
  return name.replace(/\s*\(\d+\)$/, '');
}

export function groupBy<T>(items: T[], key: (item: T) => string | undefined): { [key: string]: T[] } {
  const groups: { [key: string]: T[] } = {};
  for (const item of items) {
    const k: string | undefined = key(item);
    if (k === undefined) {
      continue;
    }
    (groups[k] = groups[k] || []).push(item);
  }
  return groups;
}

export function values<T>(map: { [key: string]: T }): T[] {
  return Object.keys(map).map(k => map[k]);
}
